import { gql } from '@apollo/client';

// --- Queries ---

export const GET_FUNCTIONAL_LOCATION = gql`
  query GetFunctionalLocation($_id: String!, $teamId: String) {
    getFunctionalLocation(_id: $_id, teamId: $teamId) {
      _id
      name
      parentId
      teamId
      senderName
    }
  }
`;

export const GET_FUNCTIONAL_LOCATIONS = gql`
  query FunctionalLocations($first: Int, $after: String, $teamId: String) {
    functionalLocations(first: $first, after: $after, teamId: $teamId) {
      page {
        edges {
          node {
            _id
            name
            parentId
            teamId
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
